import * as type from './type';
import util from 'common/js/util';

export default{
    [type.GET_PERSONAL_INFO](context, option){
        util.post({
            params: {
                functionId: 'userCenter'
            },
            sc(data){
                context.commit(type.SET_PERSONAL_INFO, data.data);
                if(option && option.sc){
                    option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_BILLING_INFO](context, option){
        util.post({
            params: {
                functionId: 'getBillingInfo'
            },
            sc(data){
                context.commit(type.SET_BILLING_INFO, data.data);
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_COMPANY_INFO](context, option){
        util.post({
            params: {
                functionId: 'getCompanyInfo'
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data.data);
                }
                context.commit(type.SET_COMPANY_INFO, data.data);
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_CORPORATE_PERSON_INFO](context, option){
        util.post({
            params: {
                functionId: 'getCorporatePersonInfo'
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data.data);
                }
                context.commit(type.SET_CORPORATE_PERSON_INFO, data.data);
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //修改企业法人信息，包括修改企业名称，企业信息，法人信息
    [type.MODIFY_COMPANY_LEGAL_INFO](context, option){
        util.post({
            params: {
                functionId: 'modifyCompanyInfo',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data.data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //撤销公司名称、企业信息、法人信息的变更
    [type.REVERT_COMPANY_INFO_MODIFY](context, option){
        util.post({
            params: {
                functionId: 'cancelCmpInfoChange',
                body: JSON.stringify({
                    rejectReason: ''
                })
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data.data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取退款信息列表
    [type.GET_REFUND_INFO](context, option){
        util.post({
            params: {
                functionId: 'getRefundInfoList',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取总行列表
    [type.GET_REFUND_BANK_INFO](context, option){
        util.post({
            params: {
                functionId: 'loadRefundBankInfo',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //根据总行、省市获取分支银行列表
    [type.GET_REFUND_BRANCH_BANK_INFO](context, option){
        util.post({
            params: {
                functionId: 'loadRefundBranchBankInfo',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //根据ID获取退款信息详情
    [type.GET_REFUND_DETAIL](context, option){
        util.post({
            params: {
                functionId: 'getRefundDetail',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //提交退款信息申请
    [type.SUBMIT_REFUND_INFO](context, option){
        util.post({
            params: {
                functionId: 'submitRefundApply',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //撤销退款信息
    [type.CANCEL_REFUND_INFO](context, option){
        util.post({
            params: {
                functionId: 'cancelRefundApply',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //删除退款信息
    [type.DELETE_REFUND_INFO](context, option){
        util.post({
            params: {
                functionId: 'deleteRefundApply',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_PARENT_COMPANY_LISTS](context, option){
        util.post({
            params: {
                functionId: 'getB2BGoupInfo',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_SUB_COMPANY_LISTS](context, option){
        util.post({
            params: {
                functionId: 'getB2BGoupMemberInfo',
                body:JSON.stringify(option.params)
            },
            sc(data){
                // context.commit(type.SET_SUB_COMPANY_LISTS, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_VAT_INFO](context, option){
        util.post({
            params: {
                functionId: 'getVatList',
            },
            sc(data){
                context.commit(type.SET_VAT_INFO, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_VAT_DETAIL](context, option){
        util.post({
            params: {
                functionId: 'getVatById',
                body: JSON.stringify(option.params)
            },
            sc(data){
                context.commit(type.SET_VAT_DETAIL, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_AGENCY_INFO](context, option){
        util.post({
            params: {
                functionId: 'getAgencyInfo',
            },
            sc(data){
                context.commit(type.SET_AGENCY_INFO, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取收票地址列表
    [type.GET_DELIVERY_ADDRESS_LIST](context, option){
        util.post({
            params: {
                functionId: 'getInvoiceAddrList',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取收票地址详情
    [type.GET_DELIVERY_ADDRESS_DETAIL](context, option){
        util.post({
            params: {
                functionId: 'getInvoiceAddrById',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //提交收票地址信息
    [type.SUBMIT_DELIVERY_ADDRESS](context, option){
        util.post({
            params: {
                functionId: 'saveInvoiceAddr',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //撤销收票地址
    [type.CANCEL_DELIVERY_ADDRESS](context, option){
        util.post({
            params: {
                functionId: 'cancelInvoiceAddr',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //删除收票地址
    [type.DELETE_DELIVERY_ADDRESS](context, option){
        util.post({
            params: {
                functionId: 'deleteInvoiceAddr',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //开通卖家
    [type.OPEN_SELLER](context, option){
        util.post({
            params: {
                functionId: 'submitVenderOpeningApply',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取卖家信息
    [type.GET_SELLER_INFO](context, option){
        util.post({
            params: {
                functionId: 'getVenderInfoResp',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取卖家已售品类列表
    [type.GET_SELLER_CATEGORY](context, option){
        util.post({
            params: {
                functionId: 'showSalesCategory'
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //卖家新增品类
    [type.SELLER_ADD_CATEGORY](context, option){
        util.post({
            params: {
                functionId: 'addSalesCategory',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取卖家证照信息
    [type.GET_SELLER_LINCENCE_INFO](context, option){
        util.post({
            params: {
                functionId: 'getListByFkInfo',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取卖家开通状态
    [type.GET_SELLER_OPEN_STATUS](context, option){
        util.post({
            params: {
                functionId: 'getVenderOpeningProcessStatus'
            },
            sc(data){
                // let firstCategories = JSON.parse(data.data.firstCategorys);
                // if(firstCategories.length > 0){
                //     for(let i = 0,len = firstCategories.length; i < len; i++){
                //         firstCategories[i].name = firstCategories[i].itemNameAlias;
                //     }
                // }
                // context.commit(type.SET_SELLER_FIRST_CATEGORIES, firstCategories);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取一级品类
    [type.GET_SELLER_FIRST_CATEGORIES](context, option){
        util.post({
            params: {
                functionId: 'loadFirstCates',
                body: JSON.stringify({
                    isCEWare: true
                })
            },
            sc(data){
                if(data.data.length > 0){
                    for(let i = 0,len = data.data.length; i < len; i++){
                        data.data[i].name = data.data[i].itemNameAlias;
                    }
                }
                context.commit(type.SET_SELLER_FIRST_CATEGORIES, data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        })
    },



    [type.GET_COMPANY_SEC_INFO](context, option){
        util.post({
            params: {
                functionId: 'getCompanySecInfo',
                body:JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data.data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        })
    },

    [type.GET_GROUP_MEMBER_SEC_INFO](context, option){
        util.post({
            params: {
                functionId: 'getB2BGoupMemberSecInfo',
                body:JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data.data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        })
    },

    [type.CHANGE_SALESMAN](context, option){
        util.post({
            params: {
                functionId: 'changeSalesman',
                body:JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc(data.data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc(data);
                }
            }
        })
    },
    //基础信息修改-获取手机号验证码
    [type.SEND_PHONE_VERIFICATION_CODE](context, option){
        util.post({
            params: {
                functionId: 'sendPhoneVerificationCode',
                body:JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc(data);
                }
            }
        })
    },
    //基础信息修改-绑定手机号
    [type.BIND_USER_PHONE](context, option){
        util.post({
            params: {
                functionId: 'editPhoneVerifyVerificationCode',
                body:JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc(data);
                }
            }
        })
    },
    //基础信息修改-保存其他信息(非手机号)
    [type.UPDATE_BUSINESS_USER_INFO](context, option){
        util.post({
            params: {
                functionId: 'updateBusinessUserInfo',
                body:JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc(data);
                }
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/store/personal-center/actions.js